import { motion } from "framer-motion";
import { Layout, RefreshCw, Gauge, ShieldCheck } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];
const ICONS = {
    layout: Layout,
    refresh: RefreshCw,
    gauge: Gauge,
    shield: ShieldCheck,
};
const SPANS = ["md:col-span-3", "md:col-span-3", "md:col-span-3", "md:col-span-3"];

export default function ServicesBento({ t }) {
    return (
        <section id="sluzby" className="border-t border-white/5 px-5 sm:px-8 py-24 sm:py-28">
            <div className="mx-auto max-w-6xl">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: EASE }}
                    className="mb-14 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between"
                >
                    <div>
                        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">
                            <span className="inline-block h-px w-10 bg-glacier/60" />
                            {t.services.overline}
                        </p>
                        <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight">
                            {t.services.title}
                        </h2>
                    </div>
                    <p className="max-w-sm text-sm sm:text-base leading-relaxed text-fog">{t.services.sub}</p>
                </motion.div>

                <div data-testid="services-bento-grid" className="grid gap-5 md:grid-cols-6">
                    {t.services.items.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <motion.div
                                key={s.title}
                                data-testid="service-card-item"
                                initial={{ opacity: 0, y: 28 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.6, delay: i * 0.07, ease: EASE }}
                                className={`rounded-lg border border-white/10 bg-coal p-7 transition-[border-color] duration-500 hover:border-glacier/40 ${SPANS[i]}`}
                            >
                                <div className="mb-5 inline-flex rounded-sm border border-glacier/25 p-3 text-glacier">
                                    <Icon size={20} strokeWidth={1.6} />
                                </div>
                                <h3 className="font-display text-xl font-medium tracking-tight text-ivory">{s.title}</h3>
                                <p className="mt-2.5 max-w-xl text-sm leading-relaxed text-fog">{s.text}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
